import { render, staticRenderFns } from "./TravelBusClsList.vue?vue&type=template&id=62cd37a9&"
import script from "./TravelBusClsList.vue?vue&type=script&lang=js&"
export * from "./TravelBusClsList.vue?vue&type=script&lang=js&"
import style0 from "./TravelBusClsList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TravelBusClsList.vue"
export default component.exports